interface StatusBadgeProps {
  status: string;
}

const LABELS: Record<string, string> = {
  pending_review: 'Pending Review',
  approved: 'Approved',
  rejected: 'Rejected',
  withdrawn: 'Withdrawn',
  awaiting_contributor: 'Awaiting Contributor',
};

const CLASSES: Record<string, string> = {
  pending_review: 'status-badge--amber',
  approved: 'status-badge--green',
  rejected: 'status-badge--red',
  withdrawn: 'status-badge--grey',
  awaiting_contributor: 'status-badge--amber',
};

export default function StatusBadge({ status }: StatusBadgeProps) {
  const label = LABELS[status] || status;
  const colorClass = CLASSES[status] || 'status-badge--grey';
  return (
    <span className={`status-badge ${colorClass}`} data-status={status}>
      {label}
    </span>
  );
}
